<template>
  <div v-loading="loading" :id="chartId" style="height: 250px;width: 100%;" />
</template>

<script>
import { equipMonitorApi } from '@/api/em/detailApi'
import { debounce } from '@/utils/common'

export default {
  name: 'AnalysisPie',

  props: {
    equipid: {
      type: Number,
      default() {
        return 0
      }
    },

    random: {
      type: [Number, String],
      default: 0
    },

    offline: {
      type: Number,
      default: 0
    },
    online: {
      type: Number,
      default: 0
    },
    running: {
      type: Number,
      default: 0
    },
    alarm: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      loading: false,
      stats: {},
      chart: null,
      chartOption: {
        title: {
        },
        legend: {
          data: ['']
        },
        // grid: {
        //   left: 10,
        //   right: 10,
        //   bottom: 10,
        //   top: 50,
        //   containLabel: true
        // },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {d}%'
        },
        series: [
          {
            name: '',
            type: 'pie',
            avoidLabelOverlap: true,
            hoverAnimation: true,
            label: {
              show: false,
              position: 'inside',
              formatter: '{b}'
            },
            data: [
              { 
                value: 65,
                name: '停机时长',
                itemStyle: {
                  color: '#999'
                }
              },
              { 
                value: 65,
                name: '待机时长',
                itemStyle: {
                  color: '#e6a23c'
                }
              },
              { 
                value: 65,
                name: '运行时长',
                itemStyle: {
                  color: '#07c160'
                }
              },
              { 
                value: 65,
                name: '告警时长',
                itemStyle: {
                  color: '#f56c6c'
                }
              }
            ]
          }
        ]
      }
    }
  },

  computed: {
    chartId() {
      return `pie-${this.random}`
    }
  },

  watch: {
    random: function(newVal,oval) {
      if (this.equipid) {
        this.setChart()
      } else {
        this.disposeChart()
      }
    }
  },

  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  beforeDestroy() {
    this.disposeChart()
    window.removeEventListener('resize', this.__resizeHandler)
  },

  created: function() {
    this.setChart()
  },

  methods: {
    fetchData() {
      this.loading = true
      equipMonitorApi({ equipid: this.equipid }).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.stats = Object.assign({}, res.data)
          this.setChart()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    setChart() {
      this.chartOption.series[0].data[0].value = this.offline
      this.chartOption.series[0].data[1].value = this.online
      this.chartOption.series[0].data[2].value = this.running
      this.chartOption.series[0].data[3].value = this.alarm
      if (this.chart) this.chart.setOption(this.chartOption)
    },

    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.chartId), 'teenager')
      this.chart.setOption(this.chartOption)
    },

    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = undefined
      }
    }
  }
}
</script>
